var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.formFields),function(formfield,index){return _c(formfield.component,{key:'formField' + index,tag:"component",attrs:{"label":formfield.label,"fieldType":formfield.fieldType,"error":formfield.error},model:{value:(formfield.value),callback:function ($$v) {_vm.$set(formfield, "value", $$v)},expression:"formfield.value"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }